import { Button } from '@/components/ui/button'
import AddRut from './AddRut'
import Delete from '@/assets/Delete'
import { Dispatch, SetStateAction, useState } from 'react'
import { rutsKeys } from './constants'
import Tooltip from '@/components/compliance-assistant/Tooltip'
import ConfirmationModal from './ConfirmationModal'

export function DetailButtons({
  processData,
  setProcessData,
  enrichmentType,
  rutKey,
  isViewMode,
}: {
  processData: FormProcessData
  setProcessData: Dispatch<SetStateAction<FormProcessData>>
  enrichmentType: number | undefined
  rutKey: rutsKeys
  isViewMode: boolean
}) {
  const addRut = (rut: string) => {
    if (processData[rutKey]?.includes(rut)) return
    setProcessData((prev) => ({
      ...prev,
      [rutKey]: [...(prev[rutKey] || []), rut],
    }))
  }
  const [isModalOpen, setIsModalOpen] = useState(false)
  const handleDeleteAll = () => {
    setProcessData((prev) => ({
      ...prev,
      [rutKey]: [],
    }))
    setIsModalOpen(false)
  }
  return (
    <>
      <AddRut addRut={addRut} disabled={!enrichmentType || isViewMode} />
      <Tooltip content="Eliminar lista">
        <Button
          className="px-2"
          onClick={() => setIsModalOpen(true)}
          variant="ghost"
          type="button"
          disabled={!enrichmentType || isViewMode}
        >
          <Delete />
        </Button>
      </Tooltip>
      <ConfirmationModal
        open={isModalOpen}
        setOpen={setIsModalOpen}
        title="¿Estás seguro que deseas eliminar la lista?"
        description="Si estás seguro de la acción, haz clic en eliminar para confirmar, esta acción es irreversible."
        onConfirm={handleDeleteAll}
      />
    </>
  )
}
